<template src="./index.html"></template>
<script>
import { Field, Toast , Popup} from "vant";
import config from '@/utils/config';
import wx_api from "@/utils/wx_api";
export default {
  name: "SetRemark",
  components: { Field ,Popup},
  data() {
    return {
      name: "",
      mobile: "",
      remarks: "",
      image: [],
      save_image:[],
      BigImage: false,
      contentShow: false,
      wx_api: null,
      requestType: true
    };
  },
  mounted(){
    this.wx_api = new wx_api(); 
    let params = {
      source: this.$route.query.source, 
      ww_nick: this.$route.query.ww_nick,
      buyer_openuid: this.$route.query.buyer_openuid
    }
    this.$store.dispatch('CustomerInfo/getRemarkDesc',params).then(res=>{
      if(res.code==1000){
        this.name = res.data.name;
        this.mobile = res.data.mobile;
        this.remarks = res.data.remarks;
        this.image = JSON.parse(JSON.stringify( res.data.image));
        this.save_image = JSON.parse(JSON.stringify( res.data.image)); // 保存用的
        this.contentShow = true;
      }
    })
  },
  methods: {
    show_BigImage(url){
      this.BigImage = url
    },
    close_big_image(){
      this.BigImage = false
    },
    inputChange(){
      this.mobile = this.mobile.replace(/[^\d]/g, '')
    },
    save(){
      if(this.name.length>0){
        if((/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g.test(this.name))){
         Toast("客户名称不能有特殊字符")
          return false;
        }
        if(Number(this.name)+'' !==NaN+''){
          Toast("客户名称不能使用纯数字")
          return false;
        }
      }
      if(this.mobile!==''&&(!(/^1[3456789]\d{9}$/.test(this.mobile)))){
        Toast("请输入正确手机号")
        return false;
      }
      let params = {
        source: this.$route.query.source,
        ww_nick: this.$route.query.ww_nick,
        name: this.name,
        tel_num: this.mobile,
        remark_msg: this.remarks,
        image: this.save_image,
        buyer_openuid: this.$route.query.buyer_openuid
      }
      if(this.requestType) {
        this.requestType = false
        this.$store.dispatch('Public/inH5Record',{btn_name:'设置备注和描述页保存按钮'}).then((res)=>{
          this.$store.dispatch('CustomerInfo/saveRemarkDesc', params).then(res=>{
            if(res.code == 1000){
              Toast('保存成功')
              // 清空客户列表的数据，让客户列表重新请求
              this.$store.commit("CustomerMessage/SET_DATA", {
                key: "getMessagelist",
                data: {list:[]},
              });
              this.$store.commit("CustomerMessage/SET_DATA", {
                key: "offset",
                data: 1,
              });
              setTimeout(()=> {
                this.$router.go(-1);
              },2000);
            }
          })
        })
      }
    },
    delete_img(index){
      let new_list = this.image.filter((e,i)=>{
        return index != i
      })
      this.save_image = this.save_image.filter((e,i)=>{
        return index != i
      })
      this.image = new_list
    },
    SelectFile(){
      this.wx_api.use.chooseImage({
        count: (3 - this.image.length), // 默认9
        sizeType: ["compressed"], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ["album", "camera"], // 可以指定来源是相册还是相机，默认二者都有
        success: async (res) => {
          if(res.localIds&&res.localIds.length){
            for(let i in res.localIds){ // 上传微信服务器
              // 上传图片
              this.save_image.push( await this.wx_uploadImage( res.localIds[i]) );
              // 生成预览图
              if(config.SystemOS=='IOS'){
                this.image.push( await this.IOS_view_image( res.localIds[i]) );
              }else{
                this.image.push( res.localIds[i]);
              }
            };
          }
        },
      });
    },
    wx_uploadImage( localId ) {
      return new Promise((resolve)=>{
        this.wx_api.use.uploadImage({
          localId, // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 1, // 默认为1，显示进度提示
          success: (res)=>{
            resolve(res.serverId)
          }
        });
      })
    },
    IOS_view_image(localId){ // IOS时使用特殊预览方式
      return new Promise(resolve=>{
        this.wx_api.use.getLocalImgData({
          localId, // 图片的localID
          complete:function(res){
            resolve(res.localData) // localData是图片的base64数据，可以用img标签显示
          }
        });
      })
    },
  },
};
</script>
<style src="./index.scss" lang="scss" scoped></style>